// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing_pricing__39hrE","price":"Pricing_price__1z8Kv","info":"Pricing_info__2-82o","footer":"Pricing_footer__7l8qc"};